// extracted by mini-css-extract-plugin
export default {"main":"TabBar_main__f57kB"};